<template>
  <div class="container">
    <div>
      <img id="appIcon" alt="Painting App Icon" :src="data.appIcon">
    </div>
    <div id="appTitle">
      <label>{{data.appTitle}}</label>
    </div>
    <div id="author">
      <label>askrsw</label>
    </div>
    <div id="email">
      <label>askrsw@163.com</label>
    </div>
    <div id="appPreviewRow">
      <div class="appScreenShot">
        <img :src="data.appScreenShots[0]" />
      </div>
      <div class="appScreenShot">
        <img :src="data.appScreenShots[1]" />
      </div>
      <div class="appScreenShot">
        <img :src="data.appScreenShots[2]" />
      </div>
      <div class="clear"></div>
    </div>
    <div id="text">
      <p>{{data.appDescription}}</p>
    </div>
    <div>
      <img alt="Download form AppStore" src="@/assets/common/downloadfromappstore.png">
    </div>
  </div>
</template>

<script>
export default {
  name: 'PaintingAppView',
  props: ['data']
}
</script>

<style scoped>
#appIcon {
  width: 160px;
  height: 160px;
  border-radius: 15px;
}
#appTitle {
  font-weight: bold;
  font-size: 22px;
  margin-top: 20px;
  margin-bottom: 10px;
}
#author {
  font-weight: normal;
  font-size: 22px;
  margin-top: 10px;
}
#email {
  font-weight: normal;
  font-size: 18px;
  margin-top: 0px;
}
#text {
  margin: 0 auto;
  font-weight: normal;
  font-size: 20px;
  margin-top: 40px;
  margin-bottom: 20px;
  max-width: 800px;
}
#text p {
  margin: 0 auto;
}
#appPreviewRow {
  margin: 0 auto;
  margin-top: 30px;
  max-width: 1024px;
  float: none;
}
.appScreenShot {
  float: left;
  width: 33%;
}
.appScreenShot img{
  width: 90%;
  margin-left: 5%;
  margin-right: 5%;
  border-radius: 10px;
}
.clear{ clear:both}
</style>
